// src/pages/ChatPage.js
import React from 'react';
import ChatContainer from '../components/Chat/ChatContainer';

const ChatPage = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <ChatContainer />
        </div>
    );
};

export default ChatPage;